function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Created by pzf on 18/9/1.
 *
 */
import includes from 'lodash/includes';
import { remove } from 'lodash';
import moment from 'moment';
import { CATEGORY_TYPE, OPTION_TYPE } from './contants';
/**
 * 构建初始化数据
 * @param data
 * @param groups
 * @returns {*}
 */

export function buildFilterData(data) {
  var i = 0;
  data.forEach(function (item, index) {
    if (item.options) {
      item.options.forEach(function (option) {
        option.code = i; // 在配置时无需再配置Id，系统自动生成。

        i += 1;
      });
    }

    if (item.type === CATEGORY_TYPE.PILL) {
      if (typeof item.excluded === 'undefined') {
        item.excluded = true; // 默认为true
      }

      item.options.forEach(function (option) {
        if (option.value === OPTION_TYPE.TODAY) {
          option.value = [moment().startOf('day').toDate(), moment().endOf('day').toDate()];
        }

        if (option.value === OPTION_TYPE.YESTERDAY) {
          option.value = [moment().startOf('day').subtract(1, 'day').toDate(), moment().endOf('day').subtract(1, 'day').toDate()];
        }

        if (option.value === OPTION_TYPE.WEEK) {
          option.value = [moment().startOf('day').subtract(1, 'Week').toDate(), moment().endOf('day').toDate()];
        }

        if (option.value === OPTION_TYPE.ONE_MONTH) {
          option.value = [moment().startOf('day').subtract(1, 'Month').toDate(), moment().endOf('day').toDate()];
        }

        if (option.value === OPTION_TYPE.TWO_MONTH) {
          option.value = [moment().startOf('day').subtract(2, 'Month').toDate(), moment().endOf('day').toDate()];
        }

        if (option.value === OPTION_TYPE.THREE_MONTH) {
          option.value = [moment().startOf('day').subtract(3, 'Month').toDate(), moment().endOf('day').toDate()];
        }
      });
    }

    item.code = index; // 不用name这类业务数据来做主键，分配一个Code
  });
  return data;
}
export function getInitChoosedData(categorys) {
  var choosed = [];
  categorys.forEach(function (category) {
    if (category.type === CATEGORY_TYPE.PILL) {
      category.options.forEach(function (option) {
        if (option.active) {
          if (option.value === OPTION_TYPE.CUSTOM_DATE || option.value === OPTION_TYPE.CUSTOM_NUMBER_RANGE) {
            choosed.push(buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, getRangeText(option.customValue), option.customValue, option.code));
          } else if (option.value === OPTION_TYPE.CUSTOM_NUMBER) {
            choosed.push(buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, option.customValue, option.customValue, option.code));
          } else {
            choosed.push(buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, option.label, option.value, option.code));
          }
        }
      });
    }

    if (category.type === CATEGORY_TYPE.SEARCH) {
      if (typeof category.value !== 'undefined' && category.value !== '') {
        choosed.push(buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, category.value, category.value));
      }
    }

    if (category.type === CATEGORY_TYPE.AUTO_COMPLETE) {
      if (typeof category.value !== 'undefined' && category.value !== '') {
        choosed.push(buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, category.value, category.value));
      }
    }
  });
  return choosed;
}
export function getAdvanceInitChoosedData(advanceCategories, choosed) {
  return choosed.filter(function (item) {
    return advanceCategories.find(function (category) {
      return category.code === item.categoryCode;
    });
  });
}
/**
 * 删除选中项
 * @param items
 * @param item object | array   可以是单个或多个
 */

export function removeShoosed(items, item) {
  if (Array.isArray(item)) {
    item.forEach(function (it) {
      removeShoosed(items, it);
    });
  } else {
    var index = items.indexOf(item);
    items.splice(index, 1);
  }
}
export function clearShoosedByCategory(choosed, category) {
  for (var i = choosed.length - 1; i >= 0; i -= 1) {
    if (choosed[i].categoryCode === category.code) {
      choosed.splice(choosed.indexOf(choosed[i]), 1);
    }
  }
}
/**
 *
 * @param categoryName
 * @param categoryCode
 * @param name
 * @param value
 * @param optionCode 当type == search时为undefined
 * @returns {{categoryName: any; categoryCode: any; name: any; value: any; code: any}}
 */

export function buildChoosedItem(categoryName, categoryLabel, categoryCode, categoryType, fieldName, name, value, optionCode) {
  return {
    categoryName: categoryName,
    categoryLabel: categoryLabel,
    categoryCode: categoryCode,
    categoryType: categoryType,
    fieldName: fieldName,
    name: name,
    value: value,
    optionCode: optionCode
  };
}
export function resetOptions(category) {
  category.options.forEach(function (item) {
    item.active = false;
  });
}
export function resetAll(categories) {
  categories.forEach(function (category) {
    if (category.type === CATEGORY_TYPE.PILL) {
      category.options.forEach(function (option) {
        option.active = false;
      });
    } else if (category.type === CATEGORY_TYPE.SEARCH) {
      category.value = '';
    }
  });
}
/**
 * 根据选中项查找查询项，删除选中时使用
 * @param choosedItem
 */

export function findCategory(categories, categoryCode) {
  var findedCategory = categories.find(function (category) {
    return category.code === categoryCode;
  });
  return findedCategory;
}
/**
 * 查找选中项，需要考虑多选的情况
 * @param type
 * @param categoryCode
 * @param optionCode pill 的code
 * @return object | array
 */

export function findItemsInChoosed(choosed, type, categoryCode, optionCode) {
  if (type === CATEGORY_TYPE.PILL) {
    if (typeof optionCode === 'undefined') {
      return choosed.filter(function (item) {
        return item.categoryCode === categoryCode; // 返回array
      });
    } else {
      return choosed.find(function (item) {
        return item.categoryCode === categoryCode && item.optionCode === optionCode;
      });
    }
  } else if (type === CATEGORY_TYPE.SEARCH || type === CATEGORY_TYPE.AUTO_COMPLETE || type === CATEGORY_TYPE.MULTIPLE_SEARCH) {
    return choosed.find(function (item) {
      return item.categoryCode === categoryCode;
    });
  }
}
export function buildSearchData(choosed) {
  var data = {};
  choosed.forEach(function (item) {
    if (item.categoryType === CATEGORY_TYPE.PILL) {
      if (typeof data[item.fieldName] === 'undefined') {
        data[item.fieldName] = [];
      }

      data[item.fieldName].push(item.value);
    } else {
      data[item.fieldName] = item.value;
    }
  });
  return data;
}
export function filterCategory(categories, advances, advance) {
  advances = advances || [];
  return categories.filter(function (category) {
    return advance ? includes(advances, category.name) : !includes(advances, category.name);
  });
}
export function getRangeText(value) {
  return value.join('~');
}
export function getDateRangeText(date, format) {
  return [date[0].format(format), date[1].format(format)].join('~');
}
/**
 * 处理时间，将后面的时间改为：00:00:00-23:59:59
 * @param data
 */

export function parseDateRageValue(date) {
  return [date[0].startOf('day'), date[1].endOf('day')];
}
export function mergeAdvanceShoosed(parentChoose, advanceChoose, advances) {
  // 加法
  // 修复同一类多选的问题 pzf
  advanceChoose.forEach(function (ad) {
    var find = parentChoose.find(function (p) {
      return ad.categoryType === CATEGORY_TYPE.PILL ? ad.categoryCode === p.categoryCode && ad.optionCode === p.optionCode : ad.categoryCode === p.categoryCode;
    });

    if (!find) {
      parentChoose.push(ad);
    } else {
      _extends(find, ad);
    }
  }); // 减法

  var removeCode = [];
  var i = parentChoose.length;

  var _loop = function _loop() {
    var p = parentChoose[i];

    if (advances.indexOf(p.categoryName) !== -1) {
      var find = advanceChoose.find(function (ad) {
        return ad.categoryType === CATEGORY_TYPE.PILL ? ad.categoryCode === p.categoryCode && ad.optionCode === p.optionCode : ad.categoryCode === p.categoryCode;
      });

      if (!find) {
        parentChoose.splice(i, 1);
      }
    }
  };

  while (i--) {
    _loop();
  }
}
export function deepClone(obj) {
  var _obj = JSON.stringify(obj),
      objClone = JSON.parse(_obj);

  return objClone;
}
export function findChoosedOptions(category) {
  var selectedOptions = [];
  category.options.forEach(function (o) {
    if (o.active) {
      selectedOptions.push(o.code);
    }
  });
  return selectedOptions;
}
//# sourceMappingURL=util.js.map
